import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import "./sections/courseDropdown.scss";
import { node } from "prop-types";

export default function BrowseNavbar(props) {
  let { navbarCategory } = props;
  const [categoryCourseList, setCategoryCourseList] = useState([]);
  const [showCourseList, setCourseList] = useState(false);
  const [headerName, setHeaderName] = useState("");
  const [currentcategory, setCurrentCategory] = useState({});
  const data = useStaticQuery(
    graphql`
      query NavbarQuery {
        courses: allMarkdownRemark(
          filter: { frontmatter: { templateKey: { eq: "courses" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                name
                backend_slug
                price
                description
                category
                card_image {
                  childImageSharp {
                    fluid(maxWidth: 120, quality: 70) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
                instructor {
                  frontmatter {
                    name
                    image {
                      childImageSharp {
                        fluid(maxWidth: 44, quality: 70) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );

  const getCategoryCourseList = (category) => {
    let categorySlug = category?.node?.fields?.slug;
    let array = categorySlug?.split("/");
    setCategoryCourseList(
      data?.courses?.edges?.filter(
        (course) =>
          course?.node?.frontmatter?.category === array[array?.length - 2]
      )
    );
    setCourseList(true);
    setHeaderName(category?.node?.frontmatter?.name);
    setCurrentCategory(category);
  };

  const backToCategoryList = () => {
    setCourseList(false);
    setHeaderName("");
  };
  const goToLink = (link) => {
    window.location = link;
  };

  return (
    <div className="course-dropdown-wrapper">
      <div className="course-dropdown-desktop">
        <div className="list-left">
          {navbarCategory?.category?.edges.map((category, index) => {
            return (
              <div
                onMouseEnter={() => getCategoryCourseList(category)}
                className={`list-item ${
                  showCourseList && headerName == category.node.frontmatter.name
                    ? "active"
                    : ""
                }`}
                key={index}
              >
                <div className="list-name">
                  {category?.node?.frontmatter?.name}
                </div>
                <div className="list-chevron"></div>
              </div>
            );
          })}
        </div>
        {showCourseList && (
          <div className="list-right">
            <div className="list-header">POPULAR COURSES</div>
            {categoryCourseList.slice(0, 5).map((course, index) => {
              return (
                <a
                  onClick={() => {
                    goToLink(course.node?.fields?.slug);
                  }}
                  className="course-link"
                  key={index}
                >
                  {course.node?.frontmatter?.name}
                </a>
              );
            })}
            <a
              onClick={() => goToLink(currentcategory?.node?.fields?.slug)}
              className="view-all-link"
            >
              View all courses
        </a>
          </div>
        )}
      </div>
      <div className="course-dropdown-mobile">
        {navbarCategory?.category?.edges.map((category, index) => {
          return (
            <div
              onClick={() =>
                getCategoryCourseList(category)
              }
              className="list-item"
              key={index}
            >
              <div className="list-name">
                {category?.node?.frontmatter?.name}
              </div>
              <div className="list-chevron"></div>
            </div>
          );
        })}
        {showCourseList && (
          <div className="course-list-wrapper">
            <div
              className="wrapper-header"
              onClick={() => backToCategoryList()}
            >
              <div className="list-chevron left"></div>
              <div className="header-name">{headerName}</div>
            </div>
            <div className="course-list">
              <div className="list-header">POPULAR COURSES</div>
              {categoryCourseList.slice(0, 5).map((course, index) => {
                return (
                  <a  
                  onClick={() => {
                    goToLink(course.node?.fields?.slug);
                  }} 
                  className="course-link" href="#" key={index}>
                    {course.node?.frontmatter?.name}
                  </a>
                );
              })}
              <a
                onClick={() => goToLink(currentcategory?.node?.fields?.slug)}
                className="view-all-link"
              >
                View all courses
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
